import { render, staticRenderFns } from "./MergeBySimilarDomains.vue?vue&type=template&id=bf347d6a&scoped=true"
import script from "./MergeBySimilarDomains.vue?vue&type=script&lang=js"
export * from "./MergeBySimilarDomains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf347d6a",
  null
  
)

export default component.exports